import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {shallowEqual, useSelector} from 'react-redux';
import {usePopupNotesContext} from '../../contexts/PopupNotesContext';
import {StyledFieldDatepicker} from '../../../../../_common/components/FieldDatepicker';
import {StyledFieldSelect} from '../../../../../_common/components/FieldSelect';
import {StyledFieldTextareaAutosize} from '../../../../../_common/components/FieldTextareaAutosize';
import {getFieldLabel} from '../../utils/getFieldLabel';
import {filterOptions} from '../../../../../_common/utils/options';
import ButtonAction from '../../../../../_common/components/ButtonAction';
import ModalContainer from '../../../../../_common/components/ModalContainer';
import ModalHeader from '../../../../../_common/components/ModalHeader';
import ModalContent from '../../../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../../../_common/components/ModalButtonsContainer';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../../../_common/styles/styles';

const PopupEditNote = ({
                                      generalNoteID,
                                      onOpen,
                                      onEdit,
                                      disabled
                                    }) => {
  const {formatMessage} = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = async () => {
    setShow(true);
    if (onOpen) await onOpen(generalNoteID);
  };
  const handleEdit = async () => {
    if (onEdit) await onEdit(generalNoteID);
    handleCloseModal();
  };
  const prefix = 'tab-order-inspections-tasks-popup';
  const {formik, fieldNames, noteStatusTypes} = usePopupNotesContext();
  const {values, dirty} = formik;
  const {users} = useSelector((state) => ({users: state.usersReducer.users}), shallowEqual);
  const header = [
    formatMessage({id: `${prefix}-button-label-generalNote`, defaultMessage: 'General note'}),
    generalNoteID,
  ].filter(Boolean).join(' - ');

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        label={<img src={toAbsoluteUrl('/media/common/Edit_primary.svg')} alt="edit" className="w-20px h-20px"/>}
        onClick={handleShowModal}
        disabled={disabled}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={header}/>
        <ModalContent customClassnames={'bg-transparent'}>
          <StyledFieldSelect
            fieldId={fieldNames.statusTypeID}
            value={filterOptions(formik.values[fieldNames.statusTypeID])(noteStatusTypes)}
            onChange={(option) => formik.setFieldValue(fieldNames.statusTypeID, option.value)}
            options={noteStatusTypes}
            label={getFieldLabel(formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'}))}
            customContainerStyles={'py-3'}
          />
          <StyledFieldDatepicker
            value={formik.values[fieldNames.dueDate]}
            onChange={(date) => formik.setFieldValue(fieldNames.dueDate, new Date(date))}
            label={getFieldLabel(formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'}), false)}
            customContainerStyles={'py-3'}
          />
          <StyledFieldSelect
            fieldId={fieldNames.responsibleUserID}
            value={filterOptions(formik.values[fieldNames.responsibleUserID])(users)}
            onChange={(option) => formik.setFieldValue(fieldNames.responsibleUserID, option.value)}
            options={users}
            label={getFieldLabel(formatMessage({
              id: `${prefix}-responsibleUser`,
              defaultMessage: 'Responsible user'
            }), false)}
            customContainerStyles={'py-3'}
          />
          <StyledFieldTextareaAutosize
            fieldId={fieldNames.freeText}
            onChange={(e) => formik.setFieldValue(fieldNames.freeText, e.target.value)}
            value={formik.values[fieldNames.freeText]}
            label={getFieldLabel(formatMessage({
              id: `${prefix}-freeText`,
              defaultMessage: 'Description'
            }), false)}
            customContainerStyles={'py-3'}
            customLabelStyles={'fs-6'}
            maxRows={6}
          />
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            label={formatMessage({id: `button-cancellation`, defaultMessage: 'Close'})}
            onClick={handleCloseModal}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={formatMessage({id: `submit`, defaultMessage: 'Submit'})}
            onClick={handleEdit}
            disabled={!values.statusTypeID || !dirty}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupEditNote;